export const API_ROOT = () => {
  if(process.env.REACT_APP_BASE_URL) return process.env.REACT_APP_BASE_URL 
  throw new Error('REACT_APP_BASE_URL not set')
}